export const environment = {
  production: true,
  apiUrl: 'https://execute.noviship.net/api',
  authUrl: 'https://execute.noviship.net/auth',
  release: 'cfe643f99a3fb614a57d26289a91164f27520000'
};
